import { gql } from "graphql-tag";

export const gamesGQL = gql`
  query Games($input: ListGamesInput!) {
    games(input: $input) {
      total
      status
      items {
        id
        title
        description
        data
        metadata
        developer
        publisher
        category
        rotationMode
        status
        type
        featured
        hasBattle
        hasSolo
        hasTournament
      }
    }
  }
`;

const gameBaseFields = gql`
  fragment GameBase on Game {
    metadata
    title
    type
    status
    orientation
    id
    description
    category
    pegiAge
    pegiContent
    developer
    publisher
    ageRatings {
      contentDescriptors
      rating
      system
    }
  }
`;

export const gameGQL = gql`
  ${gameBaseFields}
  query Game($gameId: String!) {
    game(id: $gameId) {
      ...GameBase
      hasPlayed
    }
  }
`;

export const gameUnAuthGQL = gql`
  ${gameBaseFields}
  query GameUnAuth($gameId: String!) {
    game(id: $gameId) {
      ...GameBase
    }
  }
`;

export const gamesPackGQL = gql`
  query Games($input: ListGamesInput!) {
    games(input: $input) {
      total
      items {
        id
        title
        description
        category
        metadata
        orientation
        status
        type
        pegiAge
        pegiContent
        developer
        publisher
      }
    }
  }
`;

export const gameSessionGql = gql`
  query GameSession($input: GameSessionInput!) {
    gameSession(input: $input) {
      id
      status
      launchData {
        ... on CasualHtmlLaunchData {
          __typename
          gameConfig
          launchUrl
        }
        ... on N2IStreamLaunchData {
          __typename
          launchUrl
          sessionId
        }
        ... on PCStreamLaunchData {
          __typename
          launchUrl
          streamStatusUrl
        }
        ... on BlacknutStreamLaunchData {
          __typename
          accessToken
          blacknutGameId
          refreshToken
        }
      }
    }
  }
`;

export const gameQueueStatusGQL = gql`
  query GameQueueStatus {
    gameQueueStatus {
      status
      gameQueue {
        length
        position
        waitTimeSeconds
      }
    }
  }
`;

export const gameInstallationProgressGQL = gql`
  query GameInstallationProgress($input: GameSessionInput!) {
    gameInstallationProgress(input: $input) {
      progress
    }
  }
`;

export const gameSuggestionsGQL = gql`
  query GameSuggestions($input: GameSuggestionsInput!) {
    gameSuggestions(input: $input) {
      id
      labels
      title
    }
  }
`;
